import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { ROLES } from "../models/enumeration-list.model";

@Injectable({
  providedIn: 'root'
})
export class BasedRoleOPathService {
  constructor(private dataService: DataService) { }


  private getProjectId(): string {
    return sessionStorage.getItem('projectId');
  }
  private getProfileId(): string {
    return sessionStorage.getItem('profileId');
  }
  public generateOPath(baseOPath: string, subPathMap: { [role: string]: string }): string {
    let oPathExpression = baseOPath;
    const profileId = this.getProfileId();

    let role = this.dataService.userRole
    if (subPathMap[role]) {
      oPathExpression = subPathMap[role].replace(/\{profileId\}/g, profileId);
    }


    return oPathExpression;
  }

  public checkSubprojectOPath(): string {
    const baseOPath = `ParentId='${this.getProjectId()}'`;

    const roleToOPathMap = {
      [ROLES.SubprojectDeputy]: `ParentId='${this.getProjectId()}' And (IdRefResponsibleSupport='{profileId}' Or measures.IdRefPersonResponsible='{profileId}'Or measures.MeasureResources.IdRefPerson='{profileId}'  ) `,
      [ROLES.SubprojectResponsible]: `ParentId='${this.getProjectId()}' And (IdRefresponsible='{profileId}' Or  IdRefResponsibleSupport='{profileId}' Or measures.IdRefPersonResponsible='{profileId}'Or measures.MeasureResources.IdRefPerson='{profileId}')`,

      [ROLES.MeasureManager]: `ParentId='${this.getProjectId()}' And (measures.IdRefPersonResponsible='{profileId}' Or measures.MeasureResources.IdRefPerson='{profileId}' )`,
      [ROLES.MeasureParticipant]: `ParentId='${this.getProjectId()}' And measures.MeasureResources.IdRefPerson='{profileId}'`
    };

    return this.generateOPath(baseOPath, roleToOPathMap);
  }

  public checkMeasureOPath(): string {
    const baseOPath = `!.ParentId='${this.getProjectId()}'`;
    const roleToOPathMap = {
      [ROLES.MeasureParticipant]: `!.ParentId='${this.getProjectId()}' And MeasureResources.IdRefPerson='{profileId}'`,
      [ROLES.MeasureManager]: `!.ParentId='${this.getProjectId()}' And ( IdRefPersonResponsible='{profileId}' Or MeasureResources.IdRefPerson='${this.getProfileId()}')`,
      [ROLES.SubprojectDeputy]: `!.ParentId='${this.getProjectId()}' And ( Type(xmtSubProject)[Id=^.ParentId].IdRefResponsibleSupport='{profileId}' Or MeasureResources.IdRefPerson='${this.getProfileId()}' Or IdRefPersonResponsible='{profileId}' )`,
      [ROLES.SubprojectResponsible]: `!.ParentId='${this.getProjectId()}' And ( Type(xmtSubProject)[Id=^.ParentId].IdRefresponsible='{profileId}' Or MeasureResources.IdRefPerson='${this.getProfileId()}' Or  Type(xmtSubProject)[Id=^.ParentId].IdRefResponsibleSupport='{profileId}' Or IdRefPersonResponsible='{profileId}'  )`
    };

    return this.generateOPath(baseOPath, roleToOPathMap);
  }


  public checkGantOPathForSubProject(): string {
    const baseOPath = `ParentId='${this.getProjectId()}'`;
    const roleToOPathMap = {
      [ROLES.MeasureParticipant]: `ParentId='${this.getProjectId()}' And measures.MeasureResources.IdRefPerson='{profileId}'`,
      [ROLES.MeasureManager]: `ParentId='${this.getProjectId()}' And(measures.IdRefPersonResponsible='{profileId}' Or  measures.MeasureResources.IdRefPerson='{profileId}') `,
      [ROLES.SubprojectDeputy]: `ParentId='${this.getProjectId()}' And (IdRefResponsibleSupport='{profileId}' Or measures.IdRefPersonResponsible='{profileId}' Or  measures.MeasureResources.IdRefPerson='{profileId}')`,
      [ROLES.SubprojectResponsible]: `ParentId='${this.getProjectId()}' And (IdRefresponsible='{profileId}' Or IdRefResponsibleSupport='{profileId}' Or measures.IdRefPersonResponsible='{profileId}' Or  measures.MeasureResources.IdRefPerson='{profileId}')`
    };

    return this.generateOPath(baseOPath, roleToOPathMap);
  }
  public CheckGantOpathForMeasures(): string {
    const baseOpath = 'measures'
    const roleToOPathMap = {
      [ROLES.MeasureParticipant]: `measures[MeasureTasks.collaborators.MeasureResource.IdRefPerson='{profileId}']`,
      [ROLES.MeasureManager]: `measures[IdRefPersonResponsible='{profileId}']`
    }
    return this.generateOPath(baseOpath, roleToOPathMap)
  }

  public checkMeasureTaskOPath(): string {
    const baseOPath = `!.!.ParentId='${this.getProjectId()}'`;
    const roleToOPathMap = {
      [ROLES.MeasureParticipant]: `!.!.ParentId='${this.getProjectId()}' And Type(xmtMeasure)[Id=^.ParentId].MeasureResources.IdRefPerson='{profileId}'`,
      [ROLES.MeasureManager]: `!.!.ParentId='${this.getProjectId()}' And (Type(xmtMeasure)[Id=^.ParentId].IdRefPersonResponsible='{profileId}' Or Type(xmtMeasure)[Id=^.ParentId].MeasureResources.IdRefPerson='{profileId}' )`,
      [ROLES.SubprojectDeputy]: `!.!.ParentId='${this.getProjectId()}' And (Type(xmtMeasure)[Id=^.ParentId].SubProject.IdRefResponsibleSupport='{profileId}' Or Type(xmtMeasure)[Id=^.ParentId].IdRefPersonResponsible='{profileId}' Or Type(xmtMeasure)[Id=^.ParentId].MeasureResources.IdRefPerson='{profileId}') `,
      [ROLES.SubprojectResponsible]: `!.!.ParentId='${this.getProjectId()}' And (Type(xmtMeasure)[Id=^.ParentId].SubProject.IdRefresponsible='{profileId}' Or Type(xmtMeasure)[Id=^.ParentId].SubProject.IdRefResponsibleSupport='{profileId}' Or Type(xmtMeasure)[Id=^.ParentId].IdRefPersonResponsible='{profileId}' Or Type(xmtMeasure)[Id=^.ParentId].MeasureResources.IdRefPerson='{profileId}' )`
    };

    return this.generateOPath(baseOPath, roleToOPathMap);
  }



}